import axios from 'axios';

import type { ExperimentDtoResponse } from './dto';
import { mapDtoToModel } from './mapper';
import type { Experiment } from './model/Experiment';

type SiteId = number;

const API_ROOT = `/api/v1/sites`;

function createEndpointPath(siteId: SiteId, experimentPath: string): string {
  return `${API_ROOT}/${siteId}/recordings/experiments/${experimentPath}`;
}

export async function getAllExperiments(
  siteId: SiteId,
  experimentType: 'googleExperiment' | 'optimizelyExperiment' | 'unbounceExperiment',
): Promise<Experiment[]> {
  const experimentTypeMap = {
    googleExperiment: 'go',
    optimizelyExperiment: 'opt',
    unbounceExperiment: 'ub',
  };
  const path = createEndpointPath(siteId, experimentTypeMap[experimentType]);
  const response = await axios.get<ExperimentDtoResponse>(path);

  return mapDtoToModel(response.data, experimentType);
}
